function setExternalReferrerInSessionStorage() {
  // Set localStorage to track where the user navigated to the site from
  // If the user didn't navigate to the site directly,
  // we want to send this value to sailthru on signup
  // Otherwise set it to direct so it doesn't get overwritten
  if (!sessionStorage.getItem('externalReferrer')) {
    const referrer = document.referrer || 'direct';
    sessionStorage.setItem('externalReferrer', referrer);
  }
}

function setExternalReferrerInputsOnDashboardForms() {
  const externalReferrerValue = sessionStorage.getItem('externalReferrer');
  const externalReferrerInputs = $('input[name="signup_external_referrer"]');
  if (externalReferrerValue && externalReferrerValue !== 'direct') {
    // externalReferrerValue is set to 'direct' if the user navigated directly to the page
    // In this case we don't want to send the signup_external_referrer value to sailthru
    externalReferrerInputs.val(externalReferrerValue);
  }
}

function setInternalReferrer() {
  let internalReferrer = '';
  const currentPage = window.location.href;
  const previousInternalReferrer = sessionStorage.getItem('internalReferrer');

  if (currentPage.includes('/signup')) {
    // if we're on signup page 1 or 2, use the previous referrer (the page the user was on when
    // they clicked the signup header) if it exists. or use the current page if the user
    // landed directly on the signup page
    internalReferrer = previousInternalReferrer || currentPage;
  } else {
    // use the current page as the internal referrer
    internalReferrer = currentPage;
  }

  sessionStorage.setItem('internalReferrer', internalReferrer);
  $('input[name=signup_internal_referrer]').val(internalReferrer);
}

function setReferralUrl() {
  const previousPage = document.referrer;
  const currentPage = window.location.href;
  let referralUrl = sessionStorage.getItem('referralUrl');
  const externalReferrer = sessionStorage.getItem('externalReferrer');
  const referralPages = ['/news/', '/spons/'];
  const storyreferralPages = ['com/news/', 'com/spons/'];
  const isReferral = referralPages.some((page) => previousPage.includes(page));
  const isStoryPage = storyreferralPages.some((page) => currentPage.includes(page));

  if (externalReferrer !== 'direct') {
    // Coming from an external site
    referralUrl = externalReferrer;
  } else if ((isReferral || isStoryPage) && window.location.pathname !== '/') {
    // Coming from a story
    referralUrl = sessionStorage.getItem('internalReferrer');
  } else {
    // Direct visit or topics page
    referralUrl = '';
  }

  sessionStorage.setItem('referralUrl', referralUrl);
  $('input[name=referral_url]').val(referralUrl);
}

$(document).ready(() => {
  if ($('.inline-signup').length > 0) {
    // Inline signup
    $('.inline-signup form').on('submit', () => {
      sessionStorage.setItem('referralUrl', '');
      $('input[name=referral_url]').val('');
    });
  }
  setExternalReferrerInSessionStorage();
  setExternalReferrerInputsOnDashboardForms();
  setInternalReferrer();
  setReferralUrl();
});
